import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import Button from "@amzn/meridian/button";

function ReadOnlyVolSplitPerLocationRow({
  volSplitPerLocation,
  selectedNode,
  handleEditClick,
  handleDeleteClick,
}) {
  return (
    <Table spacing="small">
      <TableRow>
        <TableCell width={100}>
          <Input value={selectedNode} />
        </TableCell>
        <TableCell width={150}>
          <Input value={volSplitPerLocation.location} />
        </TableCell>
        <TableCell width={90}>
          <Input value={parseFloat(volSplitPerLocation.value).toFixed(2)} />
        </TableCell>
        <TableCell>
          <Row>
            <Button minWidth={70} onClick={(event) => handleDeleteClick(volSplitPerLocation)}>
              Delete
            </Button>
            <Button minWidth={70} onClick={(event) => handleEditClick(volSplitPerLocation)}>
              Edit
            </Button>
          </Row>
        </TableCell>
      </TableRow>
    </Table>
  );
}

export default ReadOnlyVolSplitPerLocationRow;
